// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';
$w.onReady(function () {
if(wixWindow.formFactor === "Mobile"){
  $w("#image58").show();
  $w("#image59").show();  
  $w("#image60").show();  
  $w("#image61").show();  
  $w("#image62").show();  
}

});